export const FLOW_TYPES = {
  MOBILE_LINES: 'tarifaMovil',
  ACTIVATE_MOBILE_LINE: 'activarLineaMovil',
  XBOX_GAME_PASS: 'gamepass',
  ACTIVATE_XBOX_GAME_PASS_BONUS: 'activarBonoGamepass',
  INTERNET: 'internet',
  DEVICES: 'dispositivos',
  R2R: 'r2r',
  R2R_2: 'r2r-2',
  PACK: 'miMovistar',
  TV: 'tv',
  FTTR: 'fttr',
  BONUS: 'bonus',
  MOVISTAR_PLUS: 'movistar-plus',
  EQUIPMENT: 'equipment',
  E_SIM: 'eSim',
  MANUAL: 'manual',
  EMPLOYEES: 'employees',
  PROTECTION: 'protection',
  PREPAID: 'prepaid',
  MULTI_SIM: 'multiSim',
  CAR: 'car',
  R2R_RENEWAL: 'r2rRenewal',
  SUBSCRIPTIONS: 'subscriptions',
  CHANGE_OTT_MODALITY: 'changeOTTModality',
  DUO: 'duo',
  BILLIN: 'billin',
  SPEED_CHANGE: 'speedChange',
  R2R_AUTO_RENEWAL: 'r2rAutoRenewal',
  PACK_R2R: 'packR2R'
};

export const FLOW_TYPES_URLS = {
  SUBSCRIPTIONS: ['/order/telco/gp/subscriptions', '/order/telco/au/subscriptions'],
  EQUIPMENT: ['/order/telco/gp/equipamiento', '/order/telco/au/equipamiento'],
  E_SIM: ['/order/telco/gp/e-sim'],
  MOBILE_LINES: ['/order/telco/gp/lineas-moviles', '/order/telco/au/lineas-moviles'],
  ACTIVATE_MOBILE_LINE: ['/order/telco/gp/activar-linea-movil'],
  XBOX_GAME_PASS: ['/order/telco/gp/gamepass'],
  ACTIVATE_XBOX_GAME_PASS_BONUS: ['/order/telco/gp/activar-bono-gamepass'],
  INTERNET: ['/order/telco/au/baf'],
  DEVICES: ['/order/telco/dispositivos'],
  R2R: ['/order/telco/gp/r2r'],
  R2R_2: ['/order/telco/gp/r2r-2'],
  PACK: ['/order/telco/gp/mi-movistar'],
  TV: ['/order/telco/gp/tv'],
  FTTR: ['/order/telco/gp/fttr', '/order/telco/au/fttr'],
  BONUS: ['/order/telco/gp/bonos'],
  MOVISTAR_PLUS: ['/order/telco/gp/movistar-plus'],
  MANUAL: ['/order/telco/gp/manual'],
  EMPLOYEES: ['/order/telco/gp/empleados'],
  PROTECTION: ['/order/telco/gp/proteccion'],
  PREPAID: ['/order/telco/gp/prepago'],
  MULTI_SIM: ['/order/telco/gp/multi-sim'],
  CAR: ['/order/telco/gp/car'],
  R2R_RENEWAL: ['/order/telco/gp/renovacion-r2r'],
  CHANGE_OTT_MODALITY: ['/order/telco/gp/cambio-modalidad-ott'],
  DUO: ['/order/telco/gp/duo'],
  BILLIN: ['/order/telco/au/billin'],
  SPEED_CHANGE: ['/order/telco/gp/cambiar-velocidad'],
  R2R_AUTO_RENEWAL: ['/order/telco/gp/autorenovacion-r2r'],
  PACK_R2R: ['/order/telco/gp/pack-r2r'],
};

export const FLOW_TYPE_TCOL = {
  R2R: 0,
  DEVICES: 1,
  PACK_WITHOUT_DOWNGRADES: 2,
  PACK: 3,
  OTHER: 1,
  OTHER_NEW: 99,
};

export const INIT_TYPES = {
  REGULAR: 0,
  AFTERSALE: 1,
  TV: 2,
  NETFLIX: 3,
}